import { useState } from 'react';
import { Copy, Check, Sparkles } from 'lucide-react';
import { buildGeminiPrompt, type GeminiPromptInput } from '../lib/buildGeminiPrompt';

/**
 * 一鍵複製目前畫面所有資料當成 markdown prompt，貼到 Gemini App / ChatGPT / 任何 LLM 都能用。
 * 點 → 寫進 clipboard → 按鈕短暫顯示 ✓ 已複製 → 3 秒後 reset。
 *
 * 使用情境：盤前/盤中你想找 Gemini Pro 做 Deep Research 但懶得手抄資料時。
 */
export function GeminiCopyButton(props: GeminiPromptInput) {
  const [state, setState] = useState<'idle' | 'copied' | 'failed'>('idle');

  async function handleCopy() {
    const text = buildGeminiPrompt(props);
    try {
      await navigator.clipboard.writeText(text);
      setState('copied');
      setTimeout(() => setState('idle'), 2500);
    } catch (e) {
      console.error('[GeminiCopyButton] clipboard.writeText failed', e);
      setState('failed');
      setTimeout(() => setState('idle'), 2500);
    }
  }

  const label =
    state === 'copied' ? '已複製' :
    state === 'failed' ? '複製失敗' :
    '複製給 Gemini';
  const Icon = state === 'copied' ? Check : Copy;
  const cls =
    state === 'copied' ? 'border-(--up)/50 bg-(--up)/10 text-(--up)' :
    state === 'failed' ? 'border-(--down)/50 bg-(--down)/10 text-(--down)' :
    'border-(--border) hover:border-(--accent) text-(--text-secondary) hover:text-(--accent)';

  return (
    <button
      type="button"
      onClick={handleCopy}
      title="複製目前所有資料 → 貼到 Gemini、ChatGPT 等任何 AI 助手都能用"
      className={`inline-flex items-center gap-1.5 text-[11px] px-2 py-1 rounded border transition-colors ${cls}`}
    >
      <Sparkles size={11} className="opacity-70" />
      <Icon size={11} />
      <span className="font-semibold">{label}</span>
    </button>
  );
}
